import useAuth from "./useAuth";
import { KeycloakTokenParsed } from "keycloak-js";
import keycloakInstance from "@/initKeycloak";

export const useHasInternalNewsquawkUserRole = () => {
  const { authenticated, tokenParsed } = useAuth();

  if (!authenticated || !tokenParsed) return false;

  // hasResourceRole with no resource defaults to keycloak clientId
  const clientId = keycloakInstance.clientId;
  if (!clientId) return false;

  const roles =
    (tokenParsed as KeycloakTokenParsed).resource_access?.[clientId]?.roles ??
    [];
  return roles.includes("internal-newsquawk-user");
};
